import React from 'react';

import { Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface ConditionalTooltipProps {
  title?: string | null;
}

const ConditionalTooltip: React.FC<ConditionalTooltipProps> = ({ title }) => {
  if (!title) return null;

  return (
    <Tooltip title={title} arrow placement="top" enterTouchDelay={0} leaveTouchDelay={4000}>
      <InfoOutlinedIcon fontSize="small" color="action" sx={{ ml: 1, cursor: 'pointer' }} />
    </Tooltip>
  );
};

export default ConditionalTooltip;
